(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-simple"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-style1"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
        constructor() {
            super();
            
            const loadRecommendations = () => {
                // If it already has products (pre-rendered), just init UI and stop
                if (this.querySelector('.product-recommendations__inner')) {
                    this.initUI();
                    return;
                }

                fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        
                        // Defeat lazyloading instantly
                        this.querySelectorAll('img.lazyload').forEach(img => {
                            img.classList.remove('lazyload');
                            img.classList.add('lazyloaded');
                            if (img.hasAttribute('data-src')) img.setAttribute('src', img.getAttribute('data-src'));
                            if (img.hasAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
                        });
                        
                        this.initUI();
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            };

            // Start fetching recommendations immediately after the product page finishes loading in the background
            if (document.readyState === 'complete') {
                loadRecommendations();
            } else {
                window.addEventListener('load', loadRecommendations, { once: true });
            }
        }
        
        initUI() {
            const self = this;
            // Wait for all scripts (including deferred vendor scripts) to execute.
            // jQuery's ready handler resolves all cross-browser ready state nuances automatically.
            const initializeSlider = function($) {
                const $carousel = $(self).find('.js-carousel');
                
                // CRITICAL FIX: .slick-carousel has display:none in CSS. 
                // Slick calculates 0 width/height if we initialize while it's hidden.
                // We temporarily remove it to let the browser paint the block.
                $carousel.removeClass('slick-carousel').css('display', 'block');
                
                // FORCE synchronous layout calculation so Slick knows the exact width
                $carousel[0].offsetHeight;
                
                // Always try global first just in case, but restrict it to ONLY this carousel node
                $('body').trigger('carousel:init', $carousel);
                
                // Fallback direct initialization if global failed (Slick not initialized)
                if ($carousel.length && !$carousel.hasClass('slick-initialized')) {
                    if ($.fn && $.fn.slick) {
                        const nav = $carousel.data('nav') === true || $carousel.data('nav') === 'true';
                        const dots = $carousel.data('dots') === true || $carousel.data('dots') === 'true';
                        const infinite = $carousel.data('infinite') === true || $carousel.data('infinite') === 'true';
                        const autoplay = $carousel.data('autoplay') === true || $carousel.data('autoplay') === 'true';
                        
                        $carousel.slick({
                            arrows: nav,
                            slidesToShow: parseInt($carousel.data('columnone')) || 4,
                            slidesToScroll: 1,
                            infinite: infinite,
                            autoplay: autoplay,
                            autoplaySpeed: parseInt($carousel.data('autoplayspeed')) || 3000,
                            dots: dots,
                            responsive: [
                                { breakpoint: 992, settings: { slidesToShow: parseInt($carousel.data('columntwo')) || 3, slidesToScroll: 1 } },
                                { breakpoint: 768, settings: { slidesToShow: parseInt($carousel.data('columnthree')) || 2, slidesToScroll: 1 } },
                                { breakpoint: 480, settings: { slidesToShow: parseInt($carousel.data('columnfour')) || 1, slidesToScroll: 1 } }
                            ]
                        });
                        $carousel.addClass('slick-carousel').css('display', '');
                    } else {
                        // Slick is permanently missing or failed! Fallback to standard grid layout to prevent products from disappearing.
                        $carousel.css('display', 'flex'); 
                        $carousel.removeClass('slick-carousel');
                    }
                } else {
                    $carousel.addClass('slick-carousel').css('display', '');
                }

                // Initialize theme specific UI elements
                if (typeof vela !== 'undefined') {
                    if (vela.swatchProduct) { try { vela.swatchProduct(); } catch(e) {} }
                    if (vela.wishlist && vela.wishlist.updateWishlist) { try { vela.wishlist.updateWishlist(); } catch(e) {} }
                }
            }.bind(this);

            // Use a highly robust polling mechanism to wait for deferred vendor scripts
            // (like Slick) to finish parsing before initializing. Check both window.$ and window.jQuery.
            const checkSlick = setInterval(() => {
                const jq = (window.$ && window.$.fn && window.$.fn.slick) ? window.$ : 
                           (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) ? window.jQuery : null;
                
                if (jq) {
                    clearInterval(checkSlick);
                    jq(initializeSlider);
                }
            }, 50);

            // Safety timeout to prevent infinite polling if slick fails to load
            setTimeout(() => {
                clearInterval(checkSlick);
                const fallbackJq = window.$ || window.jQuery;
                if (fallbackJq) fallbackJq(initializeSlider);
            }, 5000);
        }
    }
    customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewed"] && !Shopify.designMode) return;
  try {
    
    var vela = window.vela || {};
    vela.recentlyViewed = {
        name: 'vela_recently_viewed',
        symbol: '|',
        maximumItems: 10,
        exists: 365,
        products: []
    };

    // Load product handle from cookie
    var cookieRecentlyViewed = vela.getCookie(vela.recentlyViewed.name);
    if (cookieRecentlyViewed !== '') {
        var products = cookieRecentlyViewed.split(vela.recentlyViewed.symbol);
        products.forEach(function(item) {
            vela.recentlyViewed.products.push(item);
        });
    }

    // Add product handle to cookie.
    var pathname = window.location.pathname;
    if (vela && pathname.indexOf('/products/') !== -1) {
        var productHandle = pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        var currentIndex = vela.recentlyViewed.products.indexOf(productHandle);
        if (currentIndex === -1) {
            // Insert to first index
            vela.recentlyViewed.products.unshift(productHandle);
            // Only take vela.recentlyViewed.maximumItems items
            vela.recentlyViewed.products = vela.recentlyViewed.products.splice(0, vela.recentlyViewed.maximumItems);
        } else {
            // Remove current handle from array
            vela.recentlyViewed.products.splice(currentIndex, 1);
            // Insert to first index
            vela.recentlyViewed.products.unshift(productHandle);
        }

        // Set cookie
        if (vela.recentlyViewed.products.length > 0) {
            var productHandles = vela.recentlyViewed.products.join(vela.recentlyViewed.symbol);
            vela.setCookie(vela.recentlyViewed.name, productHandles, vela.recentlyViewed.exists);
        }
    }

    class ProductRecentlyViewed extends HTMLElement {
        constructor() {
            super();

            this.hiddenClass = 'd-none';
            this.container = this.querySelector('[data-products]');
            this.limit = parseInt(this.dataset.limit, 10);

            if (this.container) {
                this.layout = this.container.dataset.products;

                document.addEventListener("DOMContentLoaded", (event) => {
                    this.initPages();
                });
            }
        }

        initPages() {
            if (vela && vela.recentlyViewed && vela.recentlyViewed.products) {
                if (vela.recentlyViewed.products.length > 1) {
                    this.renderPages();
                } else {
                    this.classList.add(this.hiddenClass);
                }
            } else {
                this.classList.add(this.hiddenClass);
            }
        }

        async renderPages() {
            try {
                let promises = [];
                vela.recentlyViewed.products.forEach((handle, index) => {
                    if (handle && index !== 0 && index <= this.limit) {
                        const url = `${window.Shopify.routes.root}products/${handle}?view=product-card`;
                        promises.push(
                            fetch(url)
                                .then(response => response.text())
                                .then(text => {
                                    if (text && text !== '') {
                                        let productItem = document.createElement('div');
                                        const productItemClass = this.layout === 'grid' ? 'col' : 'slick-carousel__item';
                                        productItem.classList.add(productItemClass);
                                        productItem.innerHTML = text;

                                        return {
                                            element: productItem,
                                            handle: handle,
                                            index: index
                                        };
                                    }
                                })
                                .catch(e => {
                                    console.error(e);
                                })
                        );
                    }
                });

                let data = await Promise.all(promises);
                data.forEach(item => {
                    if ('element' in item) {
                        this.container.append(item.element);
                    }
                });
                this.afterRenderPage();
            } catch (e) {
                console.error(e);
            };
        }

        afterRenderPage() {
            this.classList.remove(this.hiddenClass);
            vela.swatchProduct();

            // Update wishlist button status
            if ('wishlist' in vela && 'updateWishlist' in vela.wishlist) {
                vela.wishlist.updateWishlist();
            }

            if (this.layout === 'carousel') {
                $('body').trigger('carousel:init', '.js-recently-viewed');
            }
            $('body').trigger('vela:countdown', '[data-countdown]');
        }
    }
    customElements.define('product-recently-viewed', ProductRecentlyViewed);

  } catch(e) { console.error(e); }
})();
})();
